const INVITE_TOKEN_KEY = "p2pInviteToken";

/**
 * Erfasst einen Einladungstoken aus `?invite=<token>` oder `/join/<token>` und
 * legt ihn in `localStorage` ab. Muss **vor** dem Keycloak-Login-Redirect
 * aufgerufen werden, da die Query nach der Weiterleitung verloren geht.
 */
export function captureInviteFromUrl(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  const fromQuery = new URLSearchParams(window.location.search).get("invite");
  const fromPath = window.location.pathname.match(/^\/join\/(.+)$/)?.[1] ?? null;
  const token = fromQuery ?? fromPath;
  if (token) {
    localStorage.setItem(INVITE_TOKEN_KEY, token);
    return token;
  }
  return null;
}

export function getInviteToken(): string | undefined {
  return localStorage.getItem(INVITE_TOKEN_KEY) ?? undefined;
}

export function clearInviteToken(): void {
  localStorage.removeItem(INVITE_TOKEN_KEY);
}
